/* SitesViewRenderer.js */

"use strict";
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;

class SitesViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("sites-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _registerGridListeners() {
        this._sitesGrid.on("UserSorted", (this._onUserSorted = this._onUserSorted.bind(this)));
    }

    _unregisterGridListeners() {
        this._sitesGrid.removeListener("UserSorted", this._onUserSorted);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        // this._debouncedOnSitesPropertiesChanged.cancel();
        this._unregisterListeners();
        this._unregisterGridListeners();
        let promArr = [];

        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "SitesViewRenderer.shutdown() error.");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                return this.renderSiteDetails();
            })
            .catch((err) => err);
    }

    // Separated the render method to get jType and render
    // form without call to the model

    renderSiteDetails() {
        this._sitesGrid = new EntityGrid({
            singleSelect: false,
            columns: this._model.columnConfig,
            pagingFeed: this._model._pagingSitesFeed,
            showHeader: true,
            gridKey: `${this._model._gridKey}_selected`,
            showLinesNumber: this._model._gameEditor.renderer._rootElem.querySelector(
                "game-editor-view-actions-gl left-container"
            ),
            useUserDataStorage: false,
        });
        this._sitesGrid._renderer._emptyMessage.innerHTML = "No sub-sites for current site";
        this._rootElem.appendChild(this._sitesGrid.renderer.rootElement);

        this._registerGridListeners();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onUserSorted(eventData) {
        this._model.onUserSorted(eventData);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = SitesViewRenderer;
